import React from "react";
import {
  Commission,
  CommissionProfile,
} from "../../../core/models/entities/Commission";
import { SummaryRow } from "../OrgShell/FieldGroup";

export function formatCommission(commission?: Commission): string {
  if (!commission || !commission.value) return "Not set";
  return commission.unit === "%"
    ? `${commission.value}%`
    : `${commission.value} ${commission.unit}`;
}

interface CommissionSummaryCardProps {
  title?: string;
  commission?: CommissionProfile;
  /** Rendered top-right of the card (e.g. an "Open editor" button). */
  action?: React.ReactNode;
}

/** Compact read-only overview of a commission profile. */
export function CommissionSummaryCard({
  title = "Commission",
  commission,
  action,
}: CommissionSummaryCardProps) {
  const overrideCount =
    (commission?.typeOnly?.length ?? 0) + (commission?.methods?.length ?? 0);

  return (
    <div className="rounded-md border bg-gray-150 p-4">
      <div className="mb-2 flex items-center">
        <h4 className="flex-1 text-sm font-semibold text-gray-700">{title}</h4>
        {action}
      </div>
      <SummaryRow label="Overall commission">
        {formatCommission(commission?.overAll)}
      </SummaryRow>
      <SummaryRow label="Extra fees">
        {formatCommission(commission?.additionalFees)}
      </SummaryRow>
      <SummaryRow label="Heating fees">
        {formatCommission(commission?.heating)}
      </SummaryRow>
      <SummaryRow label="Specific overrides">
        {overrideCount > 0
          ? `${overrideCount} type/method ${
              overrideCount === 1 ? "override" : "overrides"
            }`
          : "None"}
      </SummaryRow>
    </div>
  );
}
